/* eslint-disable react/prop-types */
import React from 'react';
import { Spin } from 'antd';

const SpacerLogKpiStrip = ({ children, isLoading = false }) => (
  <div className="spacer-log-kpi-strip-wrap">
    <Spin spinning={isLoading} tip="Loading KPIs…">
      <div className="spacer-log-kpi-strip" aria-busy={isLoading}>
        {children}
      </div>
    </Spin>
  </div>
);

export default SpacerLogKpiStrip;
